import BaseService from './baseService';


export default class DashboardMgmtService extends BaseService {
    constructor() {
        super('dashboard-management');
    }

    /**
    * Loads dashboards for quicksite
    * @param {Array<number>} scenarioIds - scenarios ids
    * @returns void
    */
    loadDashboards = (scenarioIds: number[]) => this.httpPostRequest('loadTables', scenarioIds);

    /**
     * Gets load statuses for tables
     * @param scenarioIds 
     * @returns list of lookups
     */
    getLoadStatuses = (scenarioIds: number[]) => this.httpGetRequest(`getLoadStatuses/${scenarioIds}`);

    /**
    * Gets list of dashboards
    * @returns list of dashboards
    */
    getListDashboards = () => this.httpGetRequest('listDashboards');

    /**
    * Gets dashboard embed url from snowflake
    * @param taskId 
    * @param dashboardId 
    * @returns url for iframe
    */
    getDashboardEmbedUrl = (taskId: number, dashboardId: number) => this.httpGetRequest(`dashboard-url/${taskId}/${dashboardId}`);

    /**
    * Gets url for redirect to snowflake 
    * @returns url
    */
    getAdminEmbedUrl = () => this.httpGetRequest(`admin-dashboard-url`);
}
